import { CommonEntrypoint } from "entrypoint/CommonEntrypoint"; 
import 'presentation/style/index.scss'; 
import ShiftMaintenanceCont from "presentation/view/container/Shift/ShiftContMain"; 
CommonEntrypoint(<ShiftMaintenanceCont/>) 
